/**
 * @fileoverview POST handler for the "/api/calculated_attributes/:id/:app_group_id/refresh" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedAttributesIdAppGroupIdRefreshCacheKeys } from "./constants";
import type {
  PostApiCalculatedAttributesIdAppGroupIdRefreshProps,
  PostApiCalculatedAttributesIdAppGroupIdRefreshResult,
} from "./types";

// Single id only -- there is no bulk refresh endpoint.
export const postApiCalculatedAttributesIdAppGroupIdRefresh = reactQueryMutationAdapter(
  postApiCalculatedAttributesIdAppGroupIdRefreshCacheKeys,
  (
    props: PostApiCalculatedAttributesIdAppGroupIdRefreshProps
  ): Promise<PostApiCalculatedAttributesIdAppGroupIdRefreshResult> => {
    const { id, app_group_id: appGroupId } = props;
    return fetch(`/api/calculated_attributes/${id}/${appGroupId}/refresh`, "POST", undefined, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
